/* eslint-disable no-shadow */
enum SKUPopupType {
  CREATE = 'create',
  EDIT = 'edit',
  OVERWRITE = 'overwrite',
}

enum SKUPopupTitle {
  create = 'Create new SKU',
  edit = 'Edit SKU',
  overwrite = 'Overwrite Simulation Result',
}

export { SKUPopupType, SKUPopupTitle };
